"use client"

import {
    Box,
    Button,
    CardContent,
    Container,
    CssBaseline,
    IconButton,
    InputAdornment,
    TextField,
    ThemeProvider,
    Typography,
    createTheme,
    Card,
    Stack,
} from "@mui/material"
import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff"
import VisibilityIcon from "@mui/icons-material/Visibility"
import Swal from "sweetalert2"
import LockOutlinedIcon from "@mui/icons-material/LockOutlined"
import OTPInput from "react-otp-input"
import AuthServices from "../../../api/VoucherServices"
import Images from "../../../assets/images"
import { SuccessToaster } from "../../../components/Toaster"
import { useAuth } from "../../../context/index"

const VendorLogin = () => {
    const navigate = useNavigate()
    const { userLogin } = useAuth()

    const [otp, setOtp] = useState("")
    const [userObj, setUserObj] = useState(null)
    const [otpEnable, setOtpEnable] = useState(false)
    const [otpError, setOtpError] = useState(false)
    const [timer, setTimer] = useState(60)

    const [forgotPasswordMode, setForgotPasswordMode] = useState(false)
    const [forgotPasswordEmail, setForgotPasswordEmail] = useState("")
    const [forgotPasswordOtp, setForgotPasswordOtp] = useState("")
    const [forgotPasswordOtpSent, setForgotPasswordOtpSent] = useState(false)
    const [forgotPasswordOtpError, setForgotPasswordOtpError] = useState(false)
    const [forgotPasswordOtpVerified, setForgotPasswordOtpVerified] = useState(false)
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [showNewPassword, setShowNewPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [forgotPasswordTimer, setForgotPasswordTimer] = useState(0)
    const [otpToken, setOtpToken] = useState(null)

    const [partnerModal, setPartnerModal] = useState(false)
    const [showPasswordLogin, setShowPasswordLogin] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [showPassword2, setShowPassword2] = useState(false)

    useEffect(() => {
        let interval
        if (timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1)
            }, 1000)
        } else {
            clearInterval(interval)
        }
        return () => clearInterval(interval)
    }, [timer])

    useEffect(() => {
        let interval
        if (forgotPasswordTimer > 0) {
            interval = setInterval(() => {
                setForgotPasswordTimer((prev) => prev - 1)
            }, 1000)
        } else {
            clearInterval(interval)
        }
        return () => clearInterval(interval)
    }, [forgotPasswordTimer])

    const {
        register,
        handleSubmit,
        formState: { errors },
        getValues,
        reset,
    } = useForm()

    const theme = createTheme({
        palette: {
            mode: "dark",
            primary: { main: "#0EA5EA" },
            background: { default: "#0F172A", paper: "#0F172A" },
        },
        typography: {
            fontFamily: "Poppins, sans-serif",
        },
        components: {
            MuiTextField: {
                styleOverrides: {
                    root: {
                        "& .MuiOutlinedInput-root": {
                            borderRadius: 10,
                        },
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: 10,
                        textTransform: "none",
                        fontWeight: 700,
                    },
                },
            },
        },
    })

    const onSubmit = async (formData) => {
        setPartnerModal(false)
        try {
            const obj = {
                name: formData?.name,
                email: formData?.email?.toLowerCase(),
                subject: formData?.subject,
                message: formData?.message,
            }
            // Keeping original behavior
        } catch (error) {
            console.error(error)
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "There was an error sending your message. Please try again later.",
                confirmButtonText: "OK",
            })
        }
    }

    const handleRegister = async (formData) => {
        console.log(formData, "formData")
        setTimer(60)
        try {
            const obj = {
                email: formData.email?.toLowerCase(),
                password: formData.password,
            }

            setUserObj(obj)
            console.log(obj)

            const { data, message } = await AuthServices.VendorLogin(obj)
            SuccessToaster(message)

            if (data?.responseCode === 206) {
                setOtpEnable(true)
                setOtpError(false)
                setOtp("")
            } else {
                userLogin(data?.vendor)
                navigate("/vendor")
            }
        } catch (error) {
            Swal.fire({
                title: "An error occurred!",
                text: error,
                icon: "error",
                confirmButtonText: "OK",
            })
        }
    }

    const submitOTP = async () => {
        try {
            const obj = {
                ...userObj,
                otp: otp,
            }
            console.log(obj, "obj")

            const data = await AuthServices.authVendorRegisterViaEmail(obj)
            console.log(data, "datadatadata")

            if (data?.responseCode === 200) {
                setOtpEnable(false)
                setOtpError(false)
                setOtp("")
                userLogin(data?.data?.vendor)
                navigate("/vendor")
            } else if (data?.responseCode === 206) {
                // OTP token received, proceed to next step
                handleRegister2(data?.data?.otp_token)
            }
        } catch (error) {
            setOtpError(true)
            Swal.fire({
                title: "An error occurred!",
                text: error,
                icon: "error",
                confirmButtonText: "OK",
            })
        }
    }

    const handleRegister2 = async (token) => {
        try {
            const obj = {
                otp_token: token,
                ...userObj,
            }

            const data = await AuthServices.authVendorRegisterViaEmail(obj)
            console.log(data)
            if (data?.responseCode === 200) {
                window.open(`${process.env.REACT_APP_DASHBOARD_URL}/continue-registration?token=${data?.data?.token}`)
            }
        } catch (error) {
            Swal.fire({
                title: "An error occurred!",
                text: error?.message || "Failed to send OTP",
                icon: "error",
                confirmButtonText: "OK",
            })
        }
    }

    const handleResendOTP = () => {
        setTimer(60)
        handleRegister(userObj)
    }

    const handleForgotPasswordClick = () => {
        setForgotPasswordMode(true)
        setForgotPasswordEmail("")
        setForgotPasswordOtp("")
        setForgotPasswordOtpSent(false)
        setForgotPasswordOtpError(false)
        setForgotPasswordOtpVerified(false)
        setNewPassword("")
        setConfirmPassword("")
    }

    const handleSendForgotPasswordOTP = async () => {
        if (!forgotPasswordEmail) {
            Swal.fire({
                title: "Error",
                text: "Please enter your email address",
                icon: "error",
                confirmButtonText: "OK",
            })
            return
        }

        try {
            setForgotPasswordTimer(60)
            const obj = {
                email: forgotPasswordEmail?.toLowerCase(),
            }

            // Call API to send OTP to email
            const data = await AuthServices.sendForgotPasswordOTP(obj)

            if (data?.responseCode === 206) {
                setForgotPasswordOtpSent(true)
                setForgotPasswordOtpError(false)
                SuccessToaster("OTP sent to your email")
            } else {
                Swal.fire({
                    title: "Error",
                    text: data?.message || "Failed to send OTP",
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }
        } catch (error) {
            Swal.fire({
                title: "An error occurred!",
                text: error?.message || "Failed to send OTP",
                icon: "error",
                confirmButtonText: "OK",
            })
        }
    }

    const handleVerifyForgotPasswordOTP = async () => {
        if (forgotPasswordOtp.length < 4) {
            setForgotPasswordOtpError(true)
            return
        }

        try {
            const obj = {
                email: forgotPasswordEmail?.toLowerCase(),
                otp: forgotPasswordOtp,
            }

            // Call API to verify OTP
            const data = await AuthServices.sendForgotPasswordOTP(obj)

            if (data?.responseCode === 206) {
                setForgotPasswordOtpError(false)
                setForgotPasswordOtpVerified(true)
                setOtpToken(data?.data?.otp_token);
                
                SuccessToaster("OTP verified successfully")
            } else {
                setForgotPasswordOtpError(true)
                setForgotPasswordOtpVerified(false)
                Swal.fire({
                    title: "Error",
                    text: data?.message || "Invalid OTP",
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }
        } catch (error) {
            setForgotPasswordOtpError(true)
            setForgotPasswordOtpVerified(false)
            Swal.fire({
                title: "An error occurred!",
                text: error?.message || "Failed to verify OTP",
                icon: "error",
                confirmButtonText: "OK",
            })
        }
    }

    const handleResetPassword = async () => {
        if (!newPassword || !confirmPassword) {
            Swal.fire({
                title: "Error",
                text: "Please enter both password fields",
                icon: "error",
                confirmButtonText: "OK",
            })
            return
        }

        if (newPassword !== confirmPassword) {
            Swal.fire({
                title: "Error",
                text: "Passwords do not match",
                icon: "error",
                confirmButtonText: "OK",
            })
            return
        }

        if (newPassword.length < 6) {
            Swal.fire({
                title: "Error",
                text: "Password must be at least 6 characters",
                icon: "error",
                confirmButtonText: "OK",
            })
            return
        }

        try {
            const obj = {
                email: forgotPasswordEmail?.toLowerCase(),
                otp: forgotPasswordOtp,
                password: newPassword,
                otp_token:otpToken
            }

            // Call API to reset password
            const data = await AuthServices.sendForgotPasswordOTP(obj)

            if (data?.responseCode === 200) {
                SuccessToaster("Password reset successfully")
                setForgotPasswordMode(false)
                setForgotPasswordEmail("")
                setForgotPasswordOtp("")
                setForgotPasswordOtpSent(false)
                setForgotPasswordOtpVerified(false)
                setNewPassword("")
                setConfirmPassword("")
            } else {
                Swal.fire({
                    title: "Error",
                    text: data?.message || "Failed to reset password",
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }
        } catch (error) {
            Swal.fire({
                title: "An error occurred!",
                text: error?.message || "Failed to reset password",
                icon: "error",
                confirmButtonText: "OK",
            })
        }
    }

    const handleResendForgotPasswordOTP = () => {
        setForgotPasswordTimer(60)
        setForgotPasswordOtpVerified(false)
        setForgotPasswordOtp("")
        handleSendForgotPasswordOTP()
    }

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: 2,
                    py: { xs: 6, md: 10 },
                    backgroundImage: `url(${Images?.frameBg || ""})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                {forgotPasswordMode ? (
                    <Container maxWidth="sm">
                        <Card
                            elevation={10}
                            sx={{
                                borderRadius: 3,
                                border: "1px solid #0EA5EA",
                                bgcolor: "background.paper",
                                backdropFilter: "blur(4px)",
                            }}
                        >
                            <CardContent sx={{ p: { xs: 4, md: 5 } }}>
                                <Stack alignItems="center" spacing={0.5} mb={3}>
                                    <LockOutlinedIcon sx={{ color: "primary.main", fontSize: 32 }} />
                                    <Typography className="heading-font" variant="h5" sx={{ fontWeight: "bold", textAlign: "center" }}>
                                        Reset Password
                                    </Typography>
                                    {!forgotPasswordOtpVerified && <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center" }}>
                                        Enter your email to receive OTP
                                    </Typography>}
                                </Stack>

                                {!forgotPasswordOtpSent ? (
                                    <>
                                        <TextField
                                            fullWidth
                                            placeholder="Email"
                                            variant="outlined"
                                            type="email"
                                            size="small"
                                            value={forgotPasswordEmail}
                                            onChange={(e) => setForgotPasswordEmail(e.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Box component={"img"} src={Images.emailIcon} width={"17px"}></Box>
                                                    </InputAdornment>
                                                ),
                                                style: {
                                                    color: "#0F172A",
                                                    fontSize: "16px",
                                                    borderRadius: 8,
                                                },
                                            }}
                                            sx={{
                                                mb: 3,
                                                backgroundColor: "transparent",
                                                "& .MuiOutlinedInput-root": {
                                                    backgroundColor: "white",
                                                    "& fieldset": { borderColor: "transparent" },
                                                    "&:hover fieldset": { borderColor: "transparent" },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: "transparent",
                                                    },
                                                },
                                            }}
                                        />

                                        <Box display="flex" gap={2}>
                                            <Button
                                                fullWidth
                                                variant="outlined"
                                                onClick={() => setForgotPasswordMode(false)}
                                                sx={{
                                                    color: "#0EA5EA",
                                                    borderColor: "#0EA5EA",
                                                }}
                                            >
                                                Back
                                            </Button>
                                            <Button fullWidth variant="contained" onClick={handleSendForgotPasswordOTP}>
                                                Send OTP
                                            </Button>
                                        </Box>
                                    </>
                                ) : (
                                    <>
                                        {!forgotPasswordOtpVerified && <Stack alignItems="center" spacing={0.5} mb={2}>
                                            <Typography sx={{ textAlign: "center" }} variant="body2" color="text.secondary">
                                                We have sent you <b>One Time Password</b> to your email
                                            </Typography>
                                            <Typography sx={{ textAlign: "center" }} variant="body2" color="primary">
                                                Please enter OTP code
                                            </Typography>
                                        </Stack>}

                                        {!forgotPasswordOtpVerified && <div className="otp-container" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                            <OTPInput
                                                value={forgotPasswordOtp}
                                                onChange={setForgotPasswordOtp}
                                                numInputs={4}
                                                renderSeparator={<span className="separator">-</span>}
                                                renderInput={(props) => <input className="otp-input" {...props} />}
                                            />
                                        </div>}

                                        {forgotPasswordOtpError && (
                                            <span
                                                style={{
                                                    color: "red",
                                                    marginTop: "5px",
                                                    fontSize: "12px",
                                                    display: "block",
                                                    marginBottom: "10px",
                                                }}
                                            >
                                                &nbsp; OTP is Invalid
                                            </span>
                                        )}

                                        {forgotPasswordOtpVerified && (
                                            <>
                                                <TextField
                                                    fullWidth
                                                    placeholder="New Password"
                                                    size="small"
                                                    variant="outlined"
                                                    type={showNewPassword ? "text" : "password"}
                                                    value={newPassword}
                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Box component={"img"} src={Images.passwordIcon} width={"17px"}></Box>
                                                            </InputAdornment>
                                                        ),
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton onClick={() => setShowNewPassword(!showNewPassword)} edge="end">
                                                                    {showNewPassword ? (
                                                                        <VisibilityIcon sx={{ color: "#0F172A", fontSize: "20px" }} />
                                                                    ) : (
                                                                        <VisibilityOffIcon sx={{ color: "#0F172A", fontSize: "20px" }} />
                                                                    )}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                        style: {
                                                            color: "#0F172A",
                                                            fontSize: "16px",
                                                            borderRadius: 8,
                                                        },
                                                    }}
                                                    sx={{
                                                        mb: 2,
                                                        "& .MuiOutlinedInput-root": {
                                                            backgroundColor: "white",
                                                            "& fieldset": { borderColor: "transparent" },
                                                            "&:hover fieldset": { borderColor: "transparent" },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "transparent",
                                                            },
                                                        },
                                                    }}
                                                />

                                                <TextField
                                                    fullWidth
                                                    placeholder="Confirm Password"
                                                    size="small"
                                                    variant="outlined"
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    value={confirmPassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Box component={"img"} src={Images.passwordIcon} width={"17px"}></Box>
                                                            </InputAdornment>
                                                        ),
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                                                                    {showConfirmPassword ? (
                                                                        <VisibilityIcon sx={{ color: "#0F172A", fontSize: "20px" }} />
                                                                    ) : (
                                                                        <VisibilityOffIcon sx={{ color: "#0F172A", fontSize: "20px" }} />
                                                                    )}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        ),
                                                        style: {
                                                            color: "#0F172A",
                                                            fontSize: "16px",
                                                            borderRadius: 8,
                                                        },
                                                    }}
                                                    sx={{
                                                        mb: 3,
                                                        "& .MuiOutlinedInput-root": {
                                                            backgroundColor: "white",
                                                            "& fieldset": { borderColor: "transparent" },
                                                            "&:hover fieldset": { borderColor: "transparent" },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "transparent",
                                                            },
                                                        },
                                                    }}
                                                />
                                            </>
                                        )}
                                        {forgotPasswordOtpVerified &&
                                            <Button
                                                fullWidth
                                                type="submit"
                                                variant="contained"
                                                onClick={handleResetPassword}

                                            >
                                                Update
                                            </Button>}
                                        {!forgotPasswordOtpVerified && <Box display="flex" justifyContent="space-between" gap={2} mt={4}>
                                            <Button
                                                fullWidth
                                                variant="outlined"
                                                disabled={forgotPasswordTimer > 0}
                                                onClick={handleResendForgotPasswordOTP}
                                                sx={{
                                                    color: forgotPasswordTimer > 0 ? "#9CA3AF" : "#0EA5EA",
                                                    borderColor: forgotPasswordTimer > 0 ? "#9CA3AF" : "#0EA5EA",
                                                }}
                                            >
                                                Resend OTP {forgotPasswordTimer !== 0 ? `in ${forgotPasswordTimer}s` : ""}
                                            </Button>

                                            <Button
                                                fullWidth
                                                type="submit"
                                                variant="contained"
                                                onClick={forgotPasswordOtpVerified ? handleResetPassword : handleVerifyForgotPasswordOTP}
                                                disabled={forgotPasswordOtp?.length < 4}
                                            >
                                                {forgotPasswordOtpVerified ? "Reset Password" : "Verify OTP"}
                                            </Button>
                                        </Box>}
                                    </>
                                )}
                            </CardContent>
                        </Card>
                    </Container>
                ) : !otpEnable ? (
                    <Container maxWidth="sm">
                        <Card
                            elevation={10}
                            sx={{
                                borderRadius: 3,
                                border: "1px solid #0EA5EA",
                                bgcolor: "background.paper",
                                backdropFilter: "blur(4px)",
                            }}
                        >
                            <CardContent sx={{ p: { xs: 4, md: 5 } }}>
                                <Stack alignItems="center" spacing={0.5} mb={3}>
                                    <LockOutlinedIcon sx={{ color: "primary.main", fontSize: 32 }} />
                                    <Typography className="heading-font" variant="h5" sx={{ fontWeight: "bold", textAlign: "center" }}>
                                        Login
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center" }}>
                                        Sign in to your vendor account
                                    </Typography>
                                </Stack>

                                <form onSubmit={handleSubmit(handleRegister)} noValidate>
                                    {/* Email */}
                                    <TextField
                                        fullWidth
                                        placeholder="Email"
                                        variant="outlined"
                                        type="email"
                                        size="small"
                                        {...register("email", { required: "Email is required" })}
                                        error={!!errors.email}
                                        helperText={errors.email ? errors.email.message : ""}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Box component={"img"} src={Images.emailIcon} width={"17px"}></Box>
                                                </InputAdornment>
                                            ),
                                            style: {
                                                color: "#0F172A",
                                                fontSize: "16px",
                                                borderRadius: 8,
                                            },
                                        }}
                                        sx={{
                                            mb: 2,
                                            backgroundColor: "transparent",
                                            "& .MuiOutlinedInput-root": {
                                                backgroundColor: "white",
                                                "& fieldset": { borderColor: "transparent" },
                                                "&:hover fieldset": { borderColor: "transparent" },
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "transparent",
                                                },
                                            },
                                            "& .MuiInputLabel-root": { color: "black" },
                                            "& .MuiInputLabel-root.Mui-focused": { color: "black" },
                                        }}
                                    />

                                    <TextField
                                        fullWidth
                                        placeholder="Password"
                                        size="small"
                                        variant="outlined"
                                        type={showPasswordLogin ? "text" : "password"}
                                        {...register("password", {
                                            required: "Password is required",
                                        })}
                                        error={!!errors.password}
                                        helperText={errors.password ? errors.password.message : ""}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Box component={"img"} src={Images.passwordIcon} width={"17px"}></Box>
                                                </InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => setShowPasswordLogin(!showPasswordLogin)} edge="end">
                                                        {showPasswordLogin ? (
                                                            <VisibilityIcon sx={{ color: "#0F172A", fontSize: "20px" }} />
                                                        ) : (
                                                            <VisibilityOffIcon sx={{ color: "#0F172A", fontSize: "20px" }} />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            style: {
                                                color: "#0F172A",
                                                fontSize: "16px",
                                                borderRadius: 8,
                                            },
                                        }}
                                        sx={{
                                            mb: 2,
                                            "& .MuiOutlinedInput-root": {
                                                backgroundColor: "white",
                                                "& fieldset": { borderColor: "transparent" },
                                                "&:hover fieldset": { borderColor: "transparent" },
                                                "&.Mui-focused fieldset": {
                                                    borderColor: "transparent",
                                                },
                                            },
                                            "& .MuiInputLabel-root": { color: "black" },
                                            "& .MuiInputLabel-root.Mui-focused": { color: "black" },
                                        }}
                                    />

                                    <Box display="flex" justifyContent="flex-end" mb={3}>
                                        <Typography
                                            
                                            variant="body2"
                                            onClick={handleForgotPasswordClick}
                                            sx={{
                                                color: "#0EA5EA",
                                                cursor: "pointer",
                                                backgroundColor:'transparent',
                                                background:'none',
                                                textDecoration: "none",
                                                "&:hover": {
                                                    textDecoration: "underline",
                                                },
                                            }}
                                        >
                                            Forgot Password?
                                        </Typography>
                                    </Box>

                                    {/* Submit */}
                                    <Button fullWidth type="submit" variant="contained" size="large" sx={{ py: 1.2 }}>
                                        Login
                                    </Button>
                                </form>
                            </CardContent>
                        </Card>
                    </Container>
                ) : (
                    <Container maxWidth="sm">
                        <Card
                            elevation={10}
                            sx={{
                                borderRadius: 3,
                                border: "1px solid #0EA5EA",
                                bgcolor: "background.paper",
                                backdropFilter: "blur(4px)",
                            }}
                        >
                            <CardContent sx={{ p: { xs: 4, md: 5 } }}>
                                <Stack alignItems="center" spacing={0.5} mb={2}>
                                    <Typography
                                        className="heading-font"
                                        variant="h5"
                                        sx={{ fontWeight: "bold", textAlign: "center", color: "#fff" }}
                                    >
                                        Verification
                                    </Typography>
                                    <Typography sx={{ textAlign: "center" }} variant="body2" color="text.secondary">
                                        We have sent you <b>One Time Password</b> to your email
                                    </Typography>
                                    <Typography sx={{ textAlign: "center" }} variant="body2" color="primary">
                                        Please enter OTP code
                                    </Typography>
                                </Stack>

                                <div className="otp-container" style={{ marginTop: "20px", marginBottom: "20px" }}>
                                    <OTPInput
                                        value={otp}
                                        onChange={setOtp}
                                        numInputs={4}
                                        renderSeparator={<span className="separator">-</span>}
                                        renderInput={(props) => <input className="otp-input" {...props} />}
                                    />
                                </div>

                                {otpError && (
                                    <span
                                        style={{ color: "red", marginTop: "5px", fontSize: "12px", display: "block", marginBottom: "10px" }}
                                    >
                                        &nbsp; OTP is Invalid
                                    </span>
                                )}

                                <Box display="flex" justifyContent="space-between" gap={2} mt={4}>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        disabled={timer > 0}
                                        onClick={handleResendOTP}
                                        sx={{
                                            color: timer > 0 ? "#9CA3AF" : "#0EA5EA",
                                            borderColor: timer > 0 ? "#9CA3AF" : "#0EA5EA",
                                        }}
                                    >
                                        Resend OTP {timer !== 0 ? `in ${timer}s` : ""}
                                    </Button>

                                    <Button fullWidth type="submit" variant="contained" onClick={submitOTP} disabled={otp?.length < 4}>
                                        Verify OTP
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Container>
                )}
            </Box>
        </ThemeProvider>
    )
}

export default VendorLogin
